import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const ModalText = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  margin: 0;
`;

export const ModalBoldText = styled.li`
  margin: 0;
`;

export const ModalList = styled.ol`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  margin: 0;
  padding-left: 15px;
`;
